(ns hai.library.connections.table
  "Connections page"
  #?(:cljs (:require-macros hai.library.connections.table))
  #?(:cljs
     (:require
      [clojure.string :as str]
      [hai.admin-ui.api-keys :as api-keys]
      [hai.sharing.components :as sharing.components]
      [hai.journal2.collection :as journal-collection]
      [hai.journal2.integration-registry :as reg]
      [hai.journal2.timeline :as journal-timeline]
      [hai.library.connections.card :as card]
      [hai.library.connections.invalid-reason :as invalid-reason]
      [hai.library.connections.setup :as setup]
      [hai.ui.components :as c]
      [hai.ui.components.collection.bulk-actions :as bulk-actions]
      [hai.ui.components.collection.filters :as filters]
      [hai.ui.components.collection.table :as collection]
      [hai.ui.components.collection.views.table :as table]
      [hai.ui.components.form.select.single-select :as single-select]
      [hai.ui.components.new-design.button :as button]
      [hai.ui.components.new-design.utils :refer [px->rem]]
      [hai.ui.icons :as icons]
      [hai.ui.rf-sugar :refer [<s >e]]
      [hai.ui.tokens :as t]
      [hai.web-app.layout :as layout]
      [hai.web-app.routing :as routing]
      [lambdaisland.ornament :as o])
     :clj
     (:require
      [hai.ui.components.new-design.utils :refer [px->rem]]
      [hai.ui.tokens :as t]
      [lambdaisland.ornament :as o])))

(o/defstyled section-title :span
  {:text-transform "uppercase"
   :font-weight "700"
   :font-size (px->rem 13)
   :color t/--text-secondary-50
   :letter-spacing "0.05em"})

(o/defstyled section-description :p
  {:color t/--hai-grey-1
   :font-size (px->rem 15)
   :margin-bottom (px->rem 16)})

(o/defstyled section-container :div
  {:margin-bottom (px->rem 40)})

(o/defstyled section-header-row :div
  :flex :items-center :justify-between
  {:margin-bottom (px->rem 4)})

#?(:cljs
   (defn type-render
     [conn]
     [table/table-cell
      (-> conn :connection/type name str/capitalize)]))

#?(:cljs
   (defn token-id-render
     [conn]
     [table/table-cell
      (-> conn :connection/token-id)]))

#?(:cljs
   (defn owner-render
     [conn]
     [table/table-cell
      (-> conn :connection/user :user/email first)]))

#?(:cljs
   (defn preview-render
     [conn]
     (case (:connection/type conn)
       :google-calendar
       [table/table-cell
        [:a {:href (routing/href :connections/preview {:connection/uuid (:connection/uuid conn)})
             :style {:cursor "pointer" :color "var(--accent-11)" :text-decoration "underline"}}
         "Preview"]]
       :linear
       [table/table-cell
        [:a {:href (routing/href :connections/linear-preview {:connection/uuid (:connection/uuid conn)})
             :style {:cursor "pointer" :color "var(--accent-11)" :text-decoration "underline"}}
         "Preview"]]
       [table/table-cell "—"])))

#?(:cljs
   (def connection-type->integration-type
     "Inverse of pathom.integration/integration-type->connection-type — used to
     look up the OAuth reconnect URL from a Connection row."
     {:google-calendar :timeline-integration.type/google-calendar
      :outlook-calendar :timeline-integration.type/outlook-calendar
      :linear          :timeline-integration.type/linear
      :github          :timeline-integration.type/github}))

#?(:cljs
   (defn status-render
     [conn]
     (let [invalid? (:connection/api-key-invalid? conn)
           {:keys [status explanation reconnect?]}
           (invalid-reason/describe (:connection/api-key-invalid-reason conn))
           it       (get connection-type->integration-type (:connection/type conn))
           url      (when (and invalid? reconnect? it) (reg/oauth-url it nil))]
       [table/table-cell
        [c/Flex {:align "center" :gap "2"}
         (if invalid?
           [c/Tooltip {:content explanation}
            [c/Badge {:color "red" :variant "soft" :radius "full"}
             status]]
           [c/Badge {:color "green" :variant "soft" :radius "full"}
            "Connected"])
         (when url
           [:a {:href url :style {:text-decoration "none"}}
            [c/Button {:variant "ghost" :size "1"} "Reconnect"]])]])))

;; ---------------------------------------------------------------------------
;; API Keys section
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn api-keys-section
     []
     [section-container
      [section-header-row
       [section-title "API KEYS"]]
      [section-description
       "Create and manage API keys to build integrations against Humble"]
      [api-keys/api-keys-ui]]))

;; ---------------------------------------------------------------------------
;; Connections section
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn connections-table
     []
     [collection/component
      {:id ::table
       :collection.view/default :collection.view/cards
       :paginate? true
       :no-items (fn [_]
                   [:div {:style {:display "flex"
                                  :flex-direction "column"
                                  :align-items "center"
                                  :justify-content "center"
                                  :padding "3rem 0"
                                  :color t/--hai-grey-1
                                  :font-size "0.9375rem"}}
                    [:span "No connections yet"]
                    [:span "Use the Add connection button above to link an external service."]])
       :query [{:user.connections/table
                [{:collection/items
                  [:connection/uuid
                   :connection/description
                   :connection/type
                   :connection/token-id
                   :connection/user
                   :connection/api-key-invalid?
                   :connection/api-key-invalid-reason
                   :connection/timeline-integration-uuid
                   :user.entity/permissions
                   sharing.components/shared-with-query]}]}]
       :columns (let [type-column {:header "Type"
                                   :render type-render
                                   :attr :connection/type
                                   :sort? false
                                   :filter {:schema :keyword
                                            :type :filter.remote/select
                                            :placeholder "Type..."
                                            :field single-select/field}}
                      status-column {:header "Status"
                                     :render status-render
                                     :attr :connection/api-key-invalid?
                                     :sort? false}
                      token-id-column {:header "Token ID"
                                       :render token-id-render
                                       :attr :connection/token-id
                                       :sort? false}
                      shared-with-column sharing.components/shared-with-column
                      description-column {:header "Description"
                                          :attr :connection/description
                                          :filter (filters/text-search
                                                   {:placeholder "Description..."})}
                      user-column  {:header "Owner"
                                    :attr :connection/user
                                    :sort? false
                                    :render owner-render
                                    :filter (filters/text-search
                                             {:placeholder "Owner..."})}]
                  (cond-> [type-column status-column]
                    @(<s :feature-flag/developer-features?)
                    (conj {:header "Preview" :render preview-render})
                    true
                    (into [token-id-column user-column shared-with-column description-column])))
       :card card/render
       :bulk-actions [{:title "Delete"
                       :mutation 'connection/delete
                       :alert {:content (fn [{:table/keys [selected] :as table} action]
                                          (let [any-linked-ti? (some :connection/timeline-integration-uuid selected)]
                                            [bulk-actions/confirm-dialog
                                             {:table  table
                                              :action action}
                                             [bulk-actions/title "Confirm Deletion of Connections"]
                                             [bulk-actions/description
                                              (if any-linked-ti?
                                                "Deleting these connections also permanently deletes their calendar timeline and history. This can't be undone."
                                                "Are you sure you want to delete the following connections?")]
                                             (into [:ul]
                                                   (map (fn [{:connection/keys [description timeline-integration-uuid]}]
                                                          [:li [:strong description]
                                                           (when timeline-integration-uuid
                                                             " — deletes its timeline too")]))
                                                   selected)]))}}]}]))

#?(:cljs
   (defn connections-section
     []
     [section-container
      [section-header-row
       [section-title "CONNECTIONS"]
       [button/dark-small
        {:on-click (fn [_] (>e [:routing/navigate [:connections/new]]))
         :text "Add connection"
         :icon [icons/plus]}]]
      [section-description
       "Link external services so Humble can pull in your data \u2014 without copying things across by hand."]
      [connections-table]]))

#?(:cljs
   (defn timeline-integrations-section
     []
     [section-container
      [section-header-row
       [section-title "INTEGRATIONS"]]
      [section-description
       "Manage your integrations and their connection status"]
      [journal-collection/integrations-table]]))

#?(:cljs
   (defn page
     [_]
     [layout/page
      [layout/breadcrumbs]
      [layout/heading]
      [layout/lead
       "Where Humble works. Connect your tools and external services so Humble can help you wherever you are."]
      [layout/content
       [setup/where-you-work]
       [connections-section]
       [timeline-integrations-section]
       [api-keys-section]]
      [journal-timeline/backfill-modal]]))
